<template>
  <div class="main">
    <Title :title="isEmpty ? 'Crear cliente' : 'Editar cliente'" />
    <div class="wrapper-client">
      <div class="wrapper-form">
        <AdminSelect
          :options="idTypeList"
          :id="'IdType'"
          v-model:text="identificationType.val"
          :value="identificationType.val"
          :label="'Tipo de identificación'"
          :has-error="identificationType.enabled"
          :error="identificationType.errors[0] ?? ''"
          :is-disabled="isEdit"
        />
        <AdminInput
          v-model:text="identificationNumber.val"
          :value="identificationNumber.val"
          :label="'Número de identificación'"
          :has-error="identificationNumber.enabled"
          :error="identificationNumber.errors[0] ?? ''"
          :is-disabled="isEdit"
        />
        <AdminInput
          v-model:text="company.val"
          :value="company.val"
          :label="'Nombre de la empresa'"
          :has-error="company.enabled"
          :error="company.errors[0] ?? ''"
        />
        <AdminInput
          v-model:text="contactName.val"
          :value="contactName.val"
          :label="'Nombre de la persona de contacto'"
          :has-error="contactName.enabled"
          :error="contactName.errors[0] ?? ''"
        />
        <AdminInput
          v-model:text="contactEmail.val"
          :value="contactEmail.val"
          :label="'Correo electrónico de contacto'"
          :has-error="contactEmail.enabled"
          :error="contactEmail.errors[0] ?? ''"
        />
        <AdminInput
          v-model:text="contactPhone.val"
          :value="contactPhone.val"
          :label="'Número de teléfono de contacto'"
          :has-error="contactPhone.enabled"
          :error="contactPhone.errors[0] ?? ''"
        />

        <div class="wrapper-check">
          <input
            type="checkbox"
            class="check"
            v-model="isSameEmail"
            @change="handleEmailCheckboxChange"
          />
          <p>Correo electrónico de contacto es el mismo de facturación</p>
        </div>

        <AdminInput
          v-model:text="billingEmail.val"
          :value="billingEmail.val"
          :label="'Correo electrónico de facturación'"
          :has-error="billingEmail.enabled"
          :error="billingEmail.errors[0] ?? ''"
          :is-disabled="isSameEmail"
        />
      </div>

      <div class="buttons">
        <StandardButton
          :buttonLabel="'Cancelar'"
          :isCancel="true"
          @click="backClientsOption"
        />
        <StandardButton
          :buttonLabel="'Guardar'"
          :is-disabled="successForm"
          @click="createEditTransactionRouter"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from "vue";
import Title from "../layoutAdmin/components/Title.vue";
import AdminInput from "@/components/commons/controls/AdminInput.vue";
import AdminSelect from "@/components/commons/controls/AdminSelect.vue";
import StandardButton from "@/components/commons/controls/StandardButton.vue";
import { createEditClientValidator } from "./validators/createEditClientValidator";
import { createEditClientUse } from "./use/createEditClientUse";

export default defineComponent({
  name: "CreateEditClient",
  components: {
    Title,
    AdminInput,
    AdminSelect,
    StandardButton,
  },
  setup() {
    const {
      identificationType,
      identificationNumber,
      company,
      contactName,
      contactEmail,
      contactPhone,
      billingEmail,
      successForm,
      reset,
    } = createEditClientValidator();

    const {
      isEmpty,
      actualClient,
      idTypeList,
      backClientsOption,
      createClientOperation,
      updateClientOperation,
    } = createEditClientUse();

    const isSameEmail = ref(false);

    function handleEmailCheckboxChange() {
      if (isSameEmail.value) {
        billingEmail.value.val = contactEmail.value.val;
      } else {
        billingEmail.value.val = "";
      }
    }

    if (!isEmpty.value) {
      identificationType.value.val =
        actualClient.value?.identificationType ?? "";
      identificationNumber.value.val =
        actualClient.value?.identificationNumber ?? "";
      company.value.val = actualClient.value?.company ?? "";
      contactName.value.val = actualClient.value?.contactName ?? "";
      contactEmail.value.val = actualClient.value?.contactEmail ?? "";
      contactPhone.value.val =
        actualClient.value?.contactPhone?.toString() ?? "";
      billingEmail.value.val = actualClient.value?.billingEmail ?? "";
      isSameEmail.value =
        actualClient.value?.contactEmail === actualClient.value?.billingEmail;
    } else {
      reset();
    }

    const isEdit = computed(() => !isEmpty.value);

    async function createEditTransactionRouter(): Promise<void> {
      isEmpty.value
        ? await createClientTransaction()
        : await updateClientTransaction();
      reset();
    }

    async function createClientTransaction() {
      await createClientOperation(
        identificationType.value.val ?? "",
        identificationNumber.value.val ?? "",
        company.value.val ?? "",
        contactName.value.val ?? "",
        contactEmail.value.val ?? "",
        Number(contactPhone.value.val) ?? "",
        billingEmail.value.val ?? "",
        isSameEmail.value
      );
      backClientsOption();
    }

    async function updateClientTransaction() {
      await updateClientOperation(
        identificationType.value.val ?? "",
        identificationNumber.value.val ?? "",
        company.value.val ?? "",
        contactName.value.val ?? "",
        contactEmail.value.val ?? "",
        Number(contactPhone.value.val) ?? "",
        billingEmail.value.val ?? "",
        isSameEmail.value
      );
      backClientsOption();
    }

    return {
      identificationType,
      identificationNumber,
      company,
      contactName,
      contactEmail,
      contactPhone,
      billingEmail,
      successForm,
      reset,

      isEdit,
      isEmpty,

      idTypeList,
      backClientsOption,
      createEditTransactionRouter,
      isSameEmail,
      handleEmailCheckboxChange,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/admin/createEditClient/styles/createEditClientStyle";
</style>
